// components
import ActionCard, {
	ActionCardProps,
} from './components/action-card/action-card'

// styles
import styles from './action-cards.module.scss'

type ActionCardsProps = {
	readonly cards: ActionCardProps[]
	readonly className?: string
}

const ActionCards = ({ cards, className }: ActionCardsProps): JSX.Element => {
	return (
		<div className={[styles.actionCards, className].join(' ').trim()}>
			{cards.map((cardProps, index) => {
				return <ActionCard key={index} {...cardProps} />
			})}
		</div>
	)
}

export default ActionCards
